import { render, staticRenderFns } from "./quickr.connection.vue?vue&type=template&id=2d536412&scoped=true"
import script from "./quickr.connection.vue?vue&type=script&lang=js"
export * from "./quickr.connection.vue?vue&type=script&lang=js"
import style0 from "./quickr.connection.vue?vue&type=style&index=0&id=2d536412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d536412",
  null
  
)

export default component.exports